import Store from './Store'
import { action, flow, makeObservable, observable } from 'mobx'
import Role from '../models/Role'
import RoleService from '../services/RoleService'
import Paginator from '../models/Paginator'

class RolesStore extends Store {
  @observable roles = []
  @observable role = new Role({})

  @observable paging = {}

  constructor () {
    super()
    makeObservable(this)
  }

  @flow
  * loadAll () {
    this.isLoading = true
    const result = yield RoleService.getRoles()
    this.paging.Roles = new Paginator(result.paginator.Roles)
    this.roles = []
    for (const role of result.roles) {
      this.roles.push(new Role(role))
    }
    this.isLoading = false
  }

  @flow
  * loadOne (roleId) {
    this.isLoading = true
    const result = yield RoleService.getRole(roleId)
    if (result) {
      this.role = new Role(result.role)
      console.log(this.role)
    }
    this.isLoading = false
  }

  @flow
  * save () {
    this.isSaving = true
    try {
      let response
      if (!this.role.id) {
        response = yield RoleService.createRole(this.role.toJson())
      } else {
        response = yield RoleService.editRole(this.role.id, this.role.toJson())
      }
      this.isSaving = false
      if (response.result.message) {
        this.addToast(response.result.message, response.result.success ? 'success' : 'error')
      }
      return response.result
    } catch (e) {
      this.addToast('Impossible de rejoindre le serveur en ce moment. Veuillez réessayer', 'error')
      throw e
    }
  }

  @action
  changePage (newPage) {
    if (newPage <= this.paging.Roles.pageCount && newPage > 0) {
      this.paging.Roles.page = newPage
      this.query.page = newPage
    }
  }
}

export default RolesStore
